module.exports = __webpack_public_path__ + "img/bullet_1531.85be7979.svg";